<template>
  <div>
    <div class="card card-custom">
      <div class="card-header">
        <h3 class="card-title">Import</h3>
      </div>
      <div class="card-body">
        <div class="row">
          <div class="col-lg-5">
            <div class="form-group">
              <label>Upload File</label>
              <div class="input-group">
                <input style="padding:4px;height:auto;line-height:inherit;" type="file" class="form-control" accept=".xls,.xlsx" id="importFile" v-on:change="onImportFileUpload1">
                <div class="input-group-append">
                  <button class="btn btn-sm btn-primary" type="button" v-on:click="importData">Import File</button>
                </div>
              </div>
            </div>
          </div>
          <div class="col-lg-3">
            <div class="form-group">
              <br />
              <a href="/Templates/ClientProfileImport Demo.xlsx" download="ClientProfileImport Demo.xlsx" class="btn btn-outline-success btn-sm">Download Sample File</a>
            </div>
          </div>
        </div>
        <div class="row" v-if="ClientProfile.length">
          <div class="col-md-12">
            <label>Invoices</label>
            <div class="col-lg-12">
              <div class="table-responsive">
                <table class="table table-bordered table-sm table-hover " width="100%">
                  <thead>
                    <tr class="bg-custom" style="color:white">
                      <td>Sr.</td>
                      <th>Title</th>
                      <th>Name</th>
                      <th>Client Type</th>
                      <th>Partner Type.</th>
                      <th>Registration Status</th>
                      <th>Business Nature</th>
                      <th>Tax Status</th>
                      <th>Active Tax Payer</th>
                      <th>Passport No.</th>
                      <th>CNIC No</th>
                      <th>GST No.</th>
                      <th>NTN No.</th>
                      <th>City</th>
                      <th>Contact Person</th>
                      <th>Mobile No.</th>
                      <th>Fax No.</th>
                      <th>Phone No.</th>
                      <th>Email</th>
                      <th>Website</th>
                      <th>UAN No.</th>
                      <th>OldCode.</th>
                      <th>Active</th>
                    </tr>
                  </thead>
                  <tbody>
                    <tr v-for="(item, ind) in ClientProfile">
                      <td align="center">{{ind + 1}}</td>
                      <td>{{item.Title}}</td>
                      <td>{{item.Name}}</td>
                      <td>{{item.ClientType}}</td>
                      <td>{{item.PartnerTypeName}}</td>
                      <td>{{item.RegistrationStatus == true ? 'Active' : 'Inactive'}}</td>
                      <td>{{item.BusinessNatureName}}</td>
                      <td>{{item.TaxStatus == true ? 'Active' : 'Inactive' }}</td>
                      <td>{{item.IsActiveTaxPayer == true ? 'Active' : 'Inactive'}}</td>
                      <td>{{item.PassportNo}}</td>
                      <td>{{item.CNICNo}}</td>
                      <td>{{item.GSTNo}}</td>
                      <td>{{item.NTNNo}}</td>
                      <td>{{item.CityName}}</td>
                      <td>{{item.ContactPerson}}</td>
                      <td>{{item.MobileNo}}</td>
                      <td>{{item.FaxNo}}</td>
                      <td>{{item.PhoneNo}}</td>
                      <td>{{item.Email}}</td>
                      <td>{{item.Website}}</td>
                      <td>{{item.UANNo}}</td>
                      <td>{{item.OldClientCode}}</td>
                      <td>{{item.Active == true ? 'Active' : 'Inactive'}}</td>
                    </tr>
                  </tbody>
                </table>
              </div>
            </div>
          </div>
        </div>
      </div>
      <div class="card-footer">
        <button type="button" class="btn btn-success btn-sm float-right" v-if="fileImported" v-on:click="save()">Save</button>
        <button class="btn btn-primary btn-sm" v-on:click="back()" type="button">Back To List</button>
      </div>
    </div>

  </div>
</template>
<script>
  import axios from 'axios'
  export default {
    data() {
      return {
        fileImported: false,
        ClientProfile: [],
        importFile: "",
      }
    },
    updated: function () {
      $("#tbl").DataTable();
    },
    methods: {

      onImportFileUpload1: function (event) {
        if (this.checkFile(event.target.files[0])) {
          startReq();
          var reader = new FileReader;
          reader.onload = (e) => {
            this.importFile = e.target.result
          }
          reader.readAsDataURL(event.target.files[0]);
          endReq();
        }
        else {
          $('#importFile').val('');
        }
      },
      importData() {
        if (!this.importFile) {
          toastr.error("No file uploaded");
          return;
        }
        startReq();
        var vm = this;
        axios.post("/api/UICApi/clientProfileImport", {
          File: vm.importFile,
        })
          .then(function (res) {
            $('#importFile').val('');
            endReq();
            if (res.data.status) {
              toastr.success("File Uploaded");
              vm.fileImported = true;
              vm.ClientProfile = res.data.ClientProfile;
            }
            else {
              toastr.error(res.data.msg);
              vm.fileImported = false;
              vm.ClientProfile = [];
            }
          })
          .catch(function (error) {
            endReq();
            vm.ClientProfile = [];
            vm.fileImported = false;
            $('#importFile').val('');
          });
      },

      checkFile(file) {
        if (file == null) {
          return false;
        }
        if (file.type != "application/vnd.openxmlformats-officedocument.spreadsheetml.sheet") {
          toastr.error("invalid file only excel sheet is allowed");
          return false;
        }
        toastr.success("Uploaded", "Done!");
        return true;
      },
      remove(ind) {
        this.orderTemplate.splice(ind, 1);
      },
      preview() {
        $("#edu").modal("show");
      },
      save() {
        var vm = this;
        startReq();
        axios.post("/api/UICApi/saveClientProfileImport", {
          ClientProfile: vm.ClientProfile,
          File: vm.importFile,
        })
          .then(function (res) {
            endReq();
            if (res.data.status) {
              toastr.success(res.data.msg);
              vm.importFile = "";
              vm.ClientProfile = [];
              vm.back();
            }
            else {
              toastr.error(res.data.msg);
            }
          })
          .catch(function (error) {
            console.log(error);
          });
      },
      back() {
        window.location.href = '/ims/BlockAccountsClientList';
      },
      trimDate(date) {
        return date ? date.split('T')[0] : '';
      }
    }
  };
</script>

<style scoped>
  .btn-xs {
    padding: 0.125rem 0.25rem;
    font-size: .75rem;
    line-height: 1.0;
    border-radius: 0.15rem;
  }

  .table {
    width: 100%;
    table-layout: fixed;
  }

  .form-control {
    height: calc(1.8125rem + 2px);
    padding: .25rem .5rem;
    font-size: 12px;
    line-height: 1.5;
    border-radius: .2rem;
  }
</style>






// WEBPACK FOOTER //
// src/components/ims/BlockAccountsClientImport.vue